<template>
    <div id="wrapper" class="info-table">
        <!--======================================================
                        Header
                ======================================================-->
        <pages-header></pages-header>

        <second-header></second-header>

        <!--======================================================
                        Main Content
                ======================================================-->
        <div class="mainContainer">
            <div class="content">
                <div class="container-fluid">
                    <div class="title">
                        <h6>{{i18n('Payment')}}</h6>
                    </div>
                    <div class="base_box_cnt full-height">
                        <form action="" id="form" class="form" @submit.prevent="submitOrder" autocomplete="off">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label for="fio">{{i18n('Card number')}}</label>
                                        <masked-input mask="1111 1111 1111 1111" class="form-control num" v-model="form.card_number" id="fio"/>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label for="expire_date">{{i18n('Card expiry date')}}  (mm/yy)</label>
                                        <masked-input mask="11/11" class="form-control num" v-model="form.expire_date" id="expire_date"/>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label for="phone">{{i18n('Phone')}}</label>
                                        <div class="input-group mb-2">
                                            <div class="input-group-prepend">
                                                <div class="input-group-text">+998</div>
                                            </div>
                                            <masked-input mask="11 111 11 11" class="form-control num" v-model="form.phone" id="phone"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p class="text-danger pull-right" v-if="errorMessage">{{errorMessage}}</p>
                        </form>
                        <div class="middle-box"></div>
                        <div class="bottom-box">
                            <div class="row">
                                <div class="offset-sm-8 col-sm-4">
                                    <button type="submit" form="form" class="btn btn-primary float-right w-100">{{i18n('Send SMS Code')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div><!--/wrapper-->
</template>

<script>
    import PagesHeader from "../components/PagesHeader";
    import SecondHeader from "../components/SecondHeader";
    import FormService from '../services/FormService';
    import FormInput from "../../js/components/FormInput";
    import MaskedInput from 'vue-masked-input';

    export default {
        name: "Data",
        components: {FormInput, SecondHeader, PagesHeader, MaskedInput},
        data() {
            return {
                errorMessage: '',
                form: new FormService({
                    card_number: '',
                    expire_date: '',
                    phone: '',
                    order_id: null
                })
            }
        },
        created() {
            if (!this.$store.state.order.id || this.$store.state.selectedSeats.length === 0) {
                this.$router.push('/');
            }
            this.form.order_id = this.$store.state.order.id;
        },
        methods: {
            submitOrder() {
                this.form.post('api/payment/validate')
                    .then(res => {
                        if (res.status === 1) {
                            this.$store.state.payment = res.data;
                            this.$router.push({name: 'web-sms'});
                        } else {
                            this.errorMessage = res.msg;
                        }
                    })
            }
        }
    }
</script>

